<template>
	<div :class="['form-group c-input-ad', { processing: processing === true }]">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<v-select
			placeholder="Search for a ad"
			v-model="text"
			@search="fetchOptions"
			:options="options"
			:filterable="false"
		>
			<template v-slot:option="option">
				<Item :ad="option" view="xs"></Item>
			</template>
			<template #open-indicator="{ attributes }">
				<svg
					v-bind="attributes"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M6 9L12 15L18 9"
						fill="none"
						stroke="currentColor"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</template>
			<template v-slot:no-options="{ search, searching, loading }">
				<span class="c-spinner dark" v-if="searching"> </span>
				<small v-else> Start typing to see suggestions. </small>
			</template>
		</v-select>
		<div
			class="c-input-ad__selected"
			v-if="selectedAd && typeof selectedAd === 'object'"
		>
			<Item v-if="selectedAd" :ad="selectedAd" view="xs"></Item>
			<article>
				<strong>Selected ad</strong>
				<small>
					<a href="#" @click="text = null"> Remove </a>
				</small>
			</article>
		</div>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription
			v-if="description"
			:message="description"
		></InputDescription>
	</div>
</template>

<script>
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

import filter from '@swipekit/lib/filter';

import Item from '@swipekit/components/item';

import api from '@swipekit/lib/api';

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
const debounce = function (func, wait = 300, immediate = false) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		}, wait);
		if (immediate && !timeout) func.apply(context, args);
	};
};

export default {
	components: {
		InputError,
		InputDescription,
		Item,
	},

	data: function () {
		return {
			text: null,

			search: '',
			offset: 0,

			options: [],

			processing: false,
		};
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		validation: {},
		value: {},
		placeholder: {
			type: String,
			default: '',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
	},

	watch: {
		text: function () {
			let temp = this.text;
			if (temp && typeof temp === 'object') {
				this.$emit('input', temp.id);
			} else {
				//this.$emit('input', null);
			}
		},
		value: function () {
			if (typeof this.value === 'object') {
				return;
			}
			let currentValue = this.text;

			let value = this.value;

			if (value !== currentValue) {
				this.text = value;
			}
		},
	},

	computed: {
		selectedAd: function () {
			console.log(this.text);
			return this.text;
		},
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
	},

	methods: {
		async loadAd(adId) {
			this.processing = true;
			const response = await api.ads.getOne(adId);

			if (response) {
				this.text = {
					...response,
					label: response.id,
					code: response.id,
				};
			}

			this.processing = false;
		},
		dropdownShouldOpen: function (vSelect) {
			return true;
		},
		fetchOptions: async function (search, loading) {
			if (search === '') {
				return;
			}

			loading(true);

			await this.loadOptions(search);

			loading(false);
		},
		loadOptions: debounce(async function (search) {
			const params = {
				skip: this.offset,
				take: 20,
				query: search,
				mediaType: 'video',
			};

			let data = await filter(params, 'filter-ad');

			data = data || [];

			try {
				data = data.map((d) => {
					let str = '';
					if (d.block.brand) {
						str = `${d.block.brand.name}`;
					}
					if (d.adTitle) {
						str = `${str} ${d.adTitle}`;
					}
					if (str.length > 20) {
						str = str.slice(0, 20) + '..';
					}
					return {
						...d,

						label: d.id,
						code: d.id,
					};
				});
			} catch (err) {
				console.log(err);
			}

			this.options = data;
		}),
	},

	mounted: function () {
		if (this.value) {
			this.loadAd(this.value);
		}
	},
};
</script>

<style lang="scss">
.c-input-ad {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);

	--vs-controls-color: var(--color-font);

	&__selected {
		display: grid;
		grid-template-columns: 140px 1fr;
		grid-column-gap: var(--margin-lg);
		align-items: center;

		article {
			strong {
				font-weight: 500;
				display: block;
			}
		}
	}

	.v-select {
		width: 100%;
	}

	.vs__dropdown-toggle {
		position: relative;
		display: inline-block;
		//width: calc(100% - 32px);
		width: 100%;
		border-color: transparent;
		font-weight: 400;
		font-size: var(--font-size);
		min-height: 32px;
		appearance: none;
		color: var(--color-font);

		padding: var(--margin);
		border-radius: var(--border-radius);
		border: var(--color-input-background) solid 1px;
		background-color: var(--color-bg-1);
		margin: 0px;
		transition: all 50ms ease-out;

		&:active,
		&:focus {
			border-color: var(--color-input-background-light);
			border-color: hsl(var(--p), 100%, 55%);
			box-shadow: 0 0 0 3px hsla(var(--p), 100%, 60%, 0.45) !important;
		}
		&:focus {
			outline: none;
			border-color: hsl(var(--p), 100%, 55%);
			box-shadow: 0 0 0 3px hsla(var(--p), 100%, 60%, 0.45) !important;
		}
	}

	.vs__actions {
		position: absolute;
		top: 0;
		right: 0;
		padding: 0;
		padding-right: var(--margin-sm);

		button {
			display: none;

			svg {
				margin-top: 0;
			}
		}

		svg {
			width: 24px;
			height: 24px;
			margin-top: 4px;
		}
	}

	.vs__selected {
		display: inline-flex;
		align-items: center;
		padding: var(--margin-lg);
		font-size: var(--font-size-xs);
		font-weight: 500;
		padding: var(--margin-sm) var(--margin-lg);
		border-radius: 4px;
		margin: var(--margin-sm) 0;
		margin-top: 0;
		margin-right: var(--margin-sm);
		background-color: var(--color-primary);
		color: var(--color-button-font);
		border: none;
		padding-right: 2px;
		--vs-controls-color: var(--color-button-font);

		cursor: pointer;

		user-select: none;

		input {
			display: none;
		}

		&:hover {
			label svg {
				opacity: 1;
			}
		}

		label {
			margin: 0;
			display: flex;
			align-items: center;
			font-size: var(--font-size-sm);

			cursor: pointer;

			svg {
				width: 20px;
				height: 20px;
				opacity: 0.5;
				margin-right: var(--margin);
			}
		}

		button {
			display: inline-flex;
			margin-left: 4px;
			width: 16px;
			height: 16px;
			background-color: var(--color-bg-2);
			border: none;
			padding: 0;
			border-radius: 99px;
			justify-content: center;
			align-items: center;
		}

		&.active {
			svg {
				color: var(--color-primary);
				opacity: 1;
			}
		}
	}

	.vs__search {
		margin-top: 0;
		appearance: none;
		border: none;

		&:focus {
			outline: none;
		}
	}

	.vs__dropdown-menu {
		max-height: 400px;
		overflow-y: auto;
		margin-top: var(--margin);
		margin-bottom: 0;
		border-radius: 5px;
		padding: var(--margin-lg);
		background: var(--color-bg-3);
		border: var(--color-bg-5) solid 1px;
		box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4),
			inset 0 4px 6px 1px rgba(255, 255, 255, 0.2),
			0 4px 10px 1px rgba(0, 0, 0, 0.2), 0 0 2px 0 rgba(0, 0, 0, 0.05);

		display: grid;
		grid-template-columns: 50% 50%;

		list-style: none;

		li {
			padding: 0;
			margin-bottom: 0;
			cursor: pointer;

			&:before {
				content: none;
			}

			.c-grid-item {
				width: 100%;
			}
		}
	}

	.vs2__listbox {
		list-style: none;
	}

	.vs__dropdown-option {
		display: flex;
		align-items: center;
		padding: var(--margin) var(--margin-lg);
		font-size: var(--font-size-sm);
		border-radius: 5px;

		&--highlight {
			//background-color: var(--color-bg-5);
			//color: var(--color-font);
		}

		&:hover,
		&:active {
			background-color: transparent;
		}

		> span {
			display: inline-block;
			width: 24px;
			height: 24px;
			margin-right: var(--margin-lg);
			border-radius: 99px;
			position: relative;
			background-color: var(--color-bg-5);

			> img {
				display: inline-block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 99px;
				object-fit: cover;
				object-position: center center;
			}
		}
	}

	.c-grid-item {
		width: 140px;
	}
}
</style>
